<script>
export default {
  name: 'BaseLayout',
  head() {
    return {
      link: [
        {
          rel: 'icon',
          href: require(`/assets/clients/${this.$store.state.config.client.toLowerCase()}/img/favicon.png`)
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('ui/setTitleDetailsActive', false); // hide dialog
  }
};
</script>
